import { round } from './round'

export function convertRadiansToDegrees(angle: number): number {
  const newAngle = angle * (180 / Math.PI)
  return round(newAngle)
}
